import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'
import { projectFilterSelector } from '@chegg-wt/core/state/projects/selectors'
import * as Styled from './styled'

import { EmptyProjectListMessageProps } from './types'
import { DEFAULT_EMPTY_MESSAGE_TEST_ID } from './constants'

export const EmptyProjectListMessage: React.FunctionComponent<EmptyProjectListMessageProps> = ({
  copy,
  projectFilter,
  testId = DEFAULT_EMPTY_MESSAGE_TEST_ID,
}) => {
  const { title, description } = copy[projectFilter]
  return (
    <Styled.EmptyMessage role="alert">
      {title && <Styled.Header data-test={`${testId}-title`}>{title}</Styled.Header>}
      <Styled.Body data-test={`${testId}-description`}>{description}</Styled.Body>
    </Styled.EmptyMessage>
  )
}

const mapStateToProps = (state: AppState) => ({
  projectFilter: projectFilterSelector(state),
})

export default connect(mapStateToProps)(EmptyProjectListMessage)
